import { ApolloError } from "@apollo/client";

export function findAmazonRequestIdForGraphQLError(error: Pick<ApolloError, "networkError">) {
    if (!error.networkError) {
        return undefined;
    }

    if (!("response" in error.networkError)) {
        return undefined;
    }

    return error.networkError.response.headers.get("x-amzn-requestid") ?? undefined;
}
